<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const filters = (props.context?.attrs?.props?.schema || []).map((item) =>
  item.filter(),
)

const handleInput = (value: any) => {
  props.context.node.input(value)
}
</script>

<template>
  <Filters2
    :model-value="context?.value"
    :schema="filters"
    @update:model-value="handleInput"
  />
</template>
